import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import flags from '../../../../icons/flags.png';
import styles from '../../../authentication/components/forgotPassword/forgotpassword.module.scss';

const OTPLoginForm = ({
  handleInputChange,
  blurredFields,
  errors,
  phone,
  handleInputBlurred,
  handleUser
}) => (
  <form name="ForgotPasswordForm" className={styles.form} onSubmit={handleUser} noValidate>
    <div className={styles.form_column}>
      <label htmlFor="email">
        <FormattedMessage id="authentication.login.email" defaultMessage="Enter your Phone Number" />
        <div>
          <ReactTelInput
            type="text"
            flagsImagePath={flags}
            onChange={(e) => { handleInputChange('phone', e); }}
            onBlur={() => { handleInputBlurred('phone'); }}
            name="phone number"
            required
            value={phone}
            classNames={styles.telephoneInput}
            defaultCountry="us"
            placeholder="Phone Number"
            inputProps={{ placeholder: 'Enter Phone Number' }}
          />
        </div>
        {blurredFields.phone && errors.phoneEmpty ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
          </small>
        ) : null}
        {errors.phoneInvalid ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_invalid" defaultMessage="Enter a valid email address" />
          </small>
        ) : null}
        {errors.LimitExcced ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.limit_excced" defaultMessage="Enter a valid email address" />
          </small>
        ) : null}
        {!blurredFields.phone || (!errors.phoneEmpty && !errors.phoneInvalid) ? (
          <small className={styles.empty_error} />) : null }
        {errors.invalidCredentials ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_invalid" defaultMessage="Enter a valid email address" />
          </small>
        ) : null}
      </label>
    </div>
    <div className={styles.button_wrapper}>
      <button
        type="submit"
        className={styles.button}
      >
        <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
      </button>
    </div>
  </form>
);


OTPLoginForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  blurredFields: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  handleInputBlurred: PropTypes.func.isRequired,
  handleUser: PropTypes.func.isRequired
};

export default OTPLoginForm;
